module.exports = __webpack_public_path__ + "static/img/title.f46ced3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/title.png
// module id = 99RW
// module chunks = 1